import { useEffect, useRef, useState } from 'react';

const ALLOWED_DIFF = 400;

const useNavMenuSizeCheck = () => {
  const menuRef = useRef<HTMLDivElement>(null);
  const [shouldUseMobileMenu, setShouldUseMobileMenu] = useState(false);
  const [savedMenuWidth, setSavedMenuWidth] = useState(0);
  const [isMounted, setIsMounted] = useState(false);

  const diffCheck = (menuWidth: any) => {
    if (menuRef.current) {
      const navWidth = document.getElementsByTagName('nav')[0].offsetWidth;
      const diff = navWidth - menuWidth;

      if (diff < ALLOWED_DIFF) {
        !shouldUseMobileMenu && setShouldUseMobileMenu(true);
      } else {
        setShouldUseMobileMenu(false);
      }
    }
  };

  // Check state on initial render
  useEffect(() => {
    if (!isMounted && menuRef.current) {
      setSavedMenuWidth(menuRef.current.offsetWidth); // We want to save the width of the menu in state in case it is removed from the DOM
      diffCheck(menuRef.current.offsetWidth);
      setIsMounted(true);
    }
  }, [isMounted, menuRef.current]);

  // Listen for window resize
  useEffect(() => {
    const listener = () => {
      if (isMounted) {
        diffCheck(savedMenuWidth);
      }
    };

    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [isMounted]);

  return {
    shouldUseMobileMenu,
    menuRef,
    isMounted,
  };
};

export default useNavMenuSizeCheck;
